// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"f36346b5","168":"791803c8","171":"77cd1ff3"}[chunkId] + ".chunk.css";
};